import bugs from "./Bugs/routes.js";
import customers from "./Customers/routes.js";
import frontendEvents from "./FrontendEvents/routes.js";
import notificationWatchers from "./NotificationWatchers/routes.js";
import users from "./Users/routes.js";

// Admin app switcher route
const adminAppRoute = {
    path: "/Admin",
    redirect: "/Admin/Users",
    name: "Admin",
    meta: {
        app: "Admin",
        sideNav: false,
        appSwitcher: true,
        appSwitcherPosition: 11,
        icon: "shield-halved",
        name: "Admin",
        security: "General.ApplicationAdmin",
        hidden(user) {
            // Hide if user has NONE of the admin flags
            return user?.Security?.General?.UserAdmin !== true && 
                   user?.Security?.General?.ApplicationAdmin !== true;
        }
    }
};

export default [
    ...users,
    ...customers,
    ...notificationWatchers,
    ...bugs,
    ...frontendEvents
];
